import { useContext } from 'react';
import type { Services } from '@/services/container';
import { ServicesContext } from './Context';

export const useServices = (): Services => {
  const services = useContext(ServicesContext);
  if (!services) throw new Error('useServices must be used within a ServicesContext.Provider');
  return services;
};
